import { BASE_PRE_ONBOARDING } from '../../QuestionnairePage/preOnboardingApi/urls';

export const GET_RECOMMEND_PLAN_STATUS = `${BASE_PRE_ONBOARDING}/plan-selected`;
export const PLAN_RECOMMENDATIONS = `${BASE_PRE_ONBOARDING}/plan-recommendations`;
export const UPDATE_PLAN_RECOMMEND_STATUS = `${BASE_PRE_ONBOARDING}/plan-selected`;
